import type { CollapseProps } from "antd";
import { Collapse } from "antd";
import type { CSSProperties } from "react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSupportedDevice } from "../../context/SupportedDeviceContext";
import MinusIcon from "./icons/MinusIcon";
import PlusIcon from "./icons/PlusIcon";

import styles from "./style.module.scss";
import "./style.scss";

const CommonIssue = () => {
  const { t } = useTranslation();
  const [activeKeys, setActiveKeys] = useState<string | string[]>([]);
  const [hasSetEvent, setHasSetEvent] = useState(false);
  const { setShowModal } = useSupportedDevice();

  const getItems: (panelStyle: CSSProperties) => CollapseProps["items"] = (
    panelStyle
  ) => {
    const qaList: any = [];
    new Array(30).fill(null).map((item, index) => {
      // hide returnExchange (Q12) because of request by PM
      if (index === 11 || index === 29 || index === 6) return "";
      //
      return qaList.push({
        key: index + 1,
        label: t(`2esim.commonissue.question${index + 1}`),
        children: (
          <div
            dangerouslySetInnerHTML={{
              __html: t(`2esim.commonissue.answer${index + 1}`, {
                brand: process.env.REACT_APP_PROD_NAME_DEV,
              }),
            }}
            className={styles.answerContainer}
          />
        ),
        style: panelStyle,
        headerClass: styles.isseTitle,
      });
    });
    return qaList;
  };
  const panelStyle: React.CSSProperties = {
    marginBottom: 16,
    borderRadius: "20px",
    border: "none",
  };

  useEffect(() => {
    const checkDeviceBtn = document.getElementById("checkDevice");
    if (checkDeviceBtn && !hasSetEvent) {
      checkDeviceBtn?.addEventListener("click", () => {
        setShowModal(true);
      });
      setHasSetEvent(true);
    }
    return () => {
      checkDeviceBtn?.removeEventListener("click", () => {
        setShowModal(true);
      });
    };
  }, [activeKeys, hasSetEvent]);

  return (
    <div className={styles.commonissue}>
      <div className={styles.topBox}>
        <div className={styles.pageTitle}>{t("normal.common.issue")}</div>
        {/* PM說先把email隱藏，我把翻譯的email刪掉 */}
        <div
          className={styles.hint}
          dangerouslySetInnerHTML={{
            __html: t("commonissue.hint"),
          }}
        />
      </div>

      <Collapse
        bordered={false}
        // defaultActiveKey={["1"]}
        expandIcon={
          ({ isActive }) => (isActive ? <MinusIcon /> : <PlusIcon />)
          // <CaretRightOutlined rotate={isActive ? 90 : 0} />
        }
        style={{ background: "transparent" }}
        items={getItems(panelStyle)}
        className="commonissue-collapse"
        onChange={(key) => {
          setActiveKeys(key);
        }}
      />
    </div>
  );
};

export default CommonIssue;
